import '../assets/stylesheets/global/animate.css'
import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['notice', 'noticeTemplate', 'alertTemplate']

  initialize() {
    window.showNotice = this.showNotice
  }

  connect() {
    document.addEventListener('turbo:before-cache', this.removeNoticeTargets)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.removeNoticeTargets)
  }

  noticeTargetConnected(element) {
    let autoHideTimeout

    // Hide after 10 secs unless body[data-permanotices=1], i.e in test env
    if (document.body.dataset.permanotices !== '1')
      autoHideTimeout = setTimeout(
        () => element.remove(),
        element.innerText.length > 60 ? 10000 : 5000
      )

    // Show the notice
    element.classList.remove('hidden')

    // Hide after click
    element.addEventListener(
      'click',
      () => {
        element.remove()
        if (autoHideTimeout) clearTimeout(autoHideTimeout)
      },
      { once: true }
    )
  }

  removeNoticeTargets = () => {
    this.noticeTargets.forEach((target) => target.remove())
  }

  showNotice = (type, message) => {
    const html = this[`${type}TemplateTarget`].innerHTML.replaceAll(
      '___MESSAGE___',
      message
    )
    this.element.insertAdjacentHTML('beforeend', html)
  }
}
